<div class="lcs-modal-content-container">
  <div class="d-flex">
    <div class="col-2">
      @if (model.preventDeletion$()) {
        <img class="img" src="/assets/icons/warning_icon.svg" width="30" height="30" alt="" />
      }
      @else {
        <span class="cpl-icon-info info-orange"></span>
      }
    </div>
    <div class="col-10">
      @if (model.preventDeletion$()) {
        <div class="justify-content-center">{{model.preventDeletionMessage$() | translate }} <br /></div>
      }
      @else {
        <div class="justify-content-center">{{'t.deleteEntityH6' | translate}} <br /></div>
      }
      <br />
      <strong>{{model.entityName$()}}?</strong>
    </div>
  </div>
  <div class="w-100">
    @if (model.promptDependencyTree$()) {
      @if (model.loadingDependencyTree$()) {
        <link-progress-bar [loading]="model.loadingDependencyTree$()"></link-progress-bar>
      }
      @else {
        <div class="d-flex justify-content-end mt-1 mb-1">
          <button mat-flat-button (click)="onExpandCollapseButtonClicked()">{{'t.treeViewExpandCollapse' | translate}}</button>
        </div>
        <p-tree [value]="model.dependencyTree$()" [filter]="true">
          <ng-template let-node pTemplate="default">
            <span>{{node.label}}</span>
            <p-chip class="ms-3" [styleClass]="node.customCssClass" [label]="node.entityTypeLabel | translate"></p-chip>
          </ng-template>
        </p-tree>
      }
    }
  </div>
</div>
